import { useCallback } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";

import { User, userStore } from "store/userStore";

const useUserStore = () => {
  const setUserStore = useSetRecoilState(userStore);

  const updateUserStore = useCallback((me: User) => setUserStore(me), [setUserStore]);

  const deleteUserStore = useCallback(() => setUserStore(null), [setUserStore]);

  const [currentUser] = useRecoilState(userStore);

  return { currentUser, updateUser: updateUserStore, deleteUser: deleteUserStore };
};

export default useUserStore;
